<!-- Botón para Givi Express -->
<div class="bg-primary" (click)="onOpen()">
    <!-- Canje remoto con Envío-->
    <ng-container *ngIf="provider?.type <= 1">
        <div>
            <div class="d-flex align-items-center">
                <div class="m-r-8">
                    <img src="assets/images/givi-express.png" width="56">
                </div>
                <div>
                    <!-- Producto -->
                    <div *ngIf="!(isCoupon || isGiftcard)" class="font-b1 text-white">
                        Express
                    </div>
                    <!-- Givi Bit -->
                    <div *ngIf="isCoupon || isGiftcard" class="font-b1 text-white">
                        Canje remoto con envío
                    </div>
                </div>
            </div>

            <div class="d-flex align-items-center">
                <div class="m-l-16 p-r-10">
                    <!-- Producto -->
                    <div *ngIf="!(isCoupon || isGiftcard)">
                        <!-- Producto -->
                        <div class="font-c1 text-white">
                            Este producto cuenta con entrega a domicilio GRATIS
                        </div>
                    </div>
                    <!-- Givi Bit -->
                    <div *ngIf="isCoupon || isGiftcard">
                        <!-- Producto -->
                        <div class="font-c1 text-white">
                            Podés canjearlo sin necesidad de ir al lugar de canje,
                            el comercio cuenta con entregas a domicilio. dale click para ver como funciona
                        </div>
                    </div>
                </div>
                <div class="text-white">
                    <i class="mdi mdi-chevron-right font-30"></i>
                </div>
            </div>
        </div>
    </ng-container>

    <!-- Canje remoto con Reservación  -->
    <ng-container *ngIf="provider?.type == 2">
        <div>
            <div class="d-flex align-items-center">
                <div class="m-r-8">
                    <img src="assets/images/givi-express-cita.png" width="56">
                </div>
                <div>
                    <div class="font-b1 text-white">
                        Canje remoto con reservación
                    </div>
                </div>
            </div>

            <div class="d-flex align-items-center">
                <div class="m-l-16 p-r-10">
                    <div class="font-c1 text-white">
                        Para poder utilizar este
                        <span *ngIf="isCoupon">Givi BIT,</span>
                        <span *ngIf="isGiftcard">Givi POP,</span>
                        primero debés hacér click en "canjear de forma remota" para reservar su espacio. 
                        Recordá que necesitás reservar ANTES de utilizar el 
                        <span *ngIf="isCoupon">Givi BIT.</span>
                        <span *ngIf="isGiftcard">Givi POP.</span>
                        Hacé clic para más detalles.
                    </div>
                </div>
                <div class="text-white">
                    <i class="mdi mdi-chevron-right font-30"></i>
                </div>
            </div>
        </div>
    </ng-container>
</div>


<ng-template #sendGiviExpressModal let-modal>
    <div class="modal-content">
        <div class="modal-body">

            <div>
                <button class="close" (click)="modal.dismiss()">
                    <i class="fa fa-times m-t-5 m-r-10"></i>
                </button>
            </div>

            <div class="border-bottom">
                 <!-- Canje remoto con Envío-->
                <div *ngIf="provider?.type <= 1" class="d-flex align-items-center p-t-10 p-b-20">
                    <div class="m-r-16">
                        <img src="assets/images/givi-express.png" width="48">
                    </div>
                    <div *ngIf="!(isCoupon || isGiftcard)" class="font-h4">
                        Express <span class="text-purple">Gratis</span>
                    </div>
                    <div *ngIf="isCoupon || isGiftcard" class="font-h4">
                        Canje remoto con envío
                    </div>
                </div>

                 <!-- Canje remoto con Reservación  -->
                <div *ngIf="provider?.type == 2" class="d-flex align-items-center p-t-10 p-b-20">
                    <div class="m-r-16">
                        <img src="assets/images/givi-express-cita.png" width="48">
                    </div>
                    <div *ngIf="isCoupon || isGiftcard" class="font-h4">
                        Canje remoto con reservación
                    </div>
                </div>
            </div>

            <div class="p-20">
                <div class="m-b-20 border-bottom">

                    <div class="m-b-20 font-c1 font-bold">
                        ¿Cómo Funciona?
                    </div>

                    <!-- Canje remoto con Envío-->
                    <ng-container *ngIf="provider?.type <= 1">
                        <div class="m-b-20 font-c1">
                            <span class="text-purple font-bold m-r-5">1.</span>
                            Para canjear tu 
                            <span *ngIf="!(isCoupon || isGiftcard)">Givi, hacés click en "Solicitar Express"</span>
                            <span *ngIf="isCoupon">Givi BIT, hacés click en "Canjear Remoto"</span>
                            <span *ngIf="isGiftcard">Givi POP, hacés click en "Canjear Remoto"</span>
                            para iniciar una conversación por WhatsApp con un mensaje y código pre-cargados para enviar directamente al comercio.
                        </div>

                        <div class="m-b-20 font-c1">
                            <span class="text-purple font-bold m-r-5">2.</span>
                            <span *ngIf="!(isCoupon || isGiftcard)">
                                Una vez que le indicás la dirección de entrega y el producto que querés adquirir.
                            </span>
                            <span *ngIf="isCoupon || isGiftcard">
                                Enviando este mensaje pre-cargado, vas a poder indicar la dirección de entrega y los productos que deseás adquirir. 
                                Una vez confirmados los detalles, el comercio calcula el monto total con el monto de tu
                                <span *ngIf="isCoupon">Givi BIT aplicado.</span>
                                <span *ngIf="isGiftcard">Givi POP aplicado.</span>
                            </span>
                        </div>

                        <div class="m-b-20 font-c1">
                            <span class="text-purple font-bold m-r-5">3.</span>
                            Cuando aceptás la orden, el comercio te canjea el
                            <span *ngIf="!(isCoupon || isGiftcard)">Givi </span>
                            <span *ngIf="isCoupon">Givi BIT </span>
                            <span *ngIf="isGiftcard">Givi POP </span>
                            y coordina la entrega a tu dirección deseada.
                        </div>

                        <div *ngIf="provider?.isFreeShipping" class="m-b-20 font-c1">
                            <span class="text-purple font-bold m-r-5">4.</span>
                            El envío está incluido SIN costo adicional.
                        </div>
                    </ng-container>
                    
                    <!-- Canje remoto con Reservación  -->
                    <ng-container *ngIf="provider?.type == 2">
                        <div class="m-b-20 font-c1">
                            <span class="text-purple font-bold m-r-5">1.</span>
                            Para canjear, hacés click en "Canje Remoto con Reservación" para iniciar una conversación 
                            por WhatsApp con un mensaje y código pre-cargados para enviar directamente al comercio.
                        </div>

                        <div class="m-b-20 font-c1">
                            <span class="text-purple font-bold m-r-5">2.</span>
                            <span>
                                Enviando este mensaje pre-cargado, vas a poder indicar fecha, hora, y los detalles respectivos para completar la reserva. 
                                Una vez confirmada tu reservación, podrás canjear tu
                                <span *ngIf="isCoupon">Givi BIT.</span>
                                <span *ngIf="isGiftcard">Givi POP.</span>
                            </span>
                        </div>

                        <div class="m-b-20 font-c1">
                            <span class="text-purple font-bold m-r-5">3.</span>
                            Finalmente, podés presentarte al comercio en la fecha y hora de la reservación para disfrutar de tu experiencia y no perdás tu espacio.
                        </div>
                    </ng-container>
                </div>

                <div *ngIf="provider?.deliveryTime" class="m-b-20 border-bottom">
                    <!-- Canje remoto con Envío  -->
                    <div *ngIf="provider?.type <= 1" class="m-b-20">
                        <i class="font-bold mdi mdi-truck-fast-outline mdi-20px text-primary m-r-10"></i>
                        <span class="font-bold font-c1 m-r-10">Tiempo de entrega:</span>
                        <span class="font-c1" [innerHTML]="provider?.deliveryTime"></span>
                    </div>
                    <!-- Canje remoto con Reservación  -->
                    <div *ngIf="provider?.type == 2" class="m-b-20">
                        <i class="font-bold mdi mdi-calendar-clock-outline mdi-20px text-primary m-r-10"></i>
                        <span class="font-bold font-c1 m-r-10">Condiciones de reserva:</span>
                        <span class="font-c1" [innerHTML]="provider?.deliveryTime"></span>
                    </div>
                </div>

                <div *ngIf="provider?.type == 2 && provider?.expressSchedule" class="m-b-20 border-bottom">
                    <div  class="m-b-20">
                        <i class="font-bold mdi mdi-calendar-remove-outline mdi-20px text-primary m-r-10" m-r-10></i>
                        <span class="font-bold font-c1 m-r-10">Política de cancelación:</span>
                        <span class="font-c1" [innerHTML]="provider?.expressSchedule"></span>
                    </div>
                </div>

                <div *ngIf="provider?.deliveryZone" class="m-b-20 border-bottom">
                    <div class="m-b-20">
                        <i class="font-bold mdi mdi-map-marker-outline mdi-20px text-primary m-r-10" m-r-10></i>
                        <span class="font-bold font-c1 m-r-10">Área de cobertura:</span>
                        <span class="font-c1" [innerHTML]="provider?.deliveryZone"></span>
                    </div>
                </div>

                <div *ngIf="givi && provider?.whatsappPhone" class="m-b-20 border-bottom">
                    <div class="m-b-20">
                        <i class="font-bold mdi mdi-whatsapp mdi-20px text-primary m-r-10"></i>
                        <span class="font-bold font-c1 m-r-10">Whatsapp:</span>
                        <span class="font-c1">{{provider?.whatsappPhone | mask: '0000-0000'}}</span>
                    </div>
                </div>

                <div class="m-b-20 border-bottom">
                    <div>
                        <i class="font-bold mdi mdi-clock-outline mdi-20px text-primary m-r-10"></i>
                        <span class="font-bold font-c1">Horarios:</span>
                    </div>
                    <div class="m-b-20 font-c1" [innerHTML]="provider?.schedule">
                    </div>
                </div>

            </div>

            <div *ngIf="givi" class="d-flex-center m-b-40">
                <button type="button" class="btn btn-primary" (click)="onSendCode()">
                    {{isCoupon || isGiftcard ? 'Canjear Remoto' : 'Solicitar Express'}}
                </button>
            </div>
        </div>
    </div>
</ng-template>